import React from 'react';

import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import useScreen from 'hooks/useScreen';
import PDPSelectUpholsteryDecideLaterUI from '../PDPSelectUpholstery/PDPSelectUpholsteryDecideLater/PDPSelectUpholsteryDecideLaterUI';

const PDPDecideLaterOverlay = () => {
  const productDetails = usePDPBasicDetails();
  const { isMobile } = useScreen();

  return (
    <div className="items-center bg-[hsla(0,0%,100%,.5)] flex h-full justify-center left-0 pointer-events-none absolute top-0 w-full z-[3]">
      <div className="text-sm font-bold bg-white rounded-sm text-gray px-6 py-3.5 lg:text-base lg:font-bold lg:px-4 lg:py-3.5 !bg-gray-light8/70">
        {isMobile ? (
          <PDPSelectUpholsteryDecideLaterUI
            promotion={productDetails?.data?.meta?.promotion}
            excludeFromSale={productDetails?.data?.exclude_from_sale}
          />
        ) : (
          'Decide Later'
        )}
      </div>
    </div>
  );
};

export default PDPDecideLaterOverlay;
